(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("text-encoding"));
	else if(typeof define === 'function' && define.amd)
		define("Library", ["text-encoding"], factory);
	else if(typeof exports === 'object')
		exports["Library"] = factory(require("text-encoding"));
	else
		root["Library"] = factory(root["text-encoding"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_37__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition